import { lerpColor } from './lerp-color.util';

const WHITE = '#ffffff';

const MAX_FADE = 0.85;

export const fadedColor = (color: string): string =>
  lerpColor(color, WHITE, MAX_FADE);
